// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"465":"208fe970","488":"a2aa0b34","984":"6c1d0afd"}[chunkId] + ".chunk.js";
};